/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTRANSFERMETHOD } from './IAPTRANSFERMETHOD';
import {
    IAPTRANSFERMETHODFromJSON,
    IAPTRANSFERMETHODFromJSONTyped,
    IAPTRANSFERMETHODToJSON,
} from './IAPTRANSFERMETHOD';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { InvestmentDetailsSourceOfMoneySplitViewModel } from './InvestmentDetailsSourceOfMoneySplitViewModel';
import {
    InvestmentDetailsSourceOfMoneySplitViewModelFromJSON,
    InvestmentDetailsSourceOfMoneySplitViewModelFromJSONTyped,
    InvestmentDetailsSourceOfMoneySplitViewModelToJSON,
} from './InvestmentDetailsSourceOfMoneySplitViewModel';
import type { UnitTransferAddSourceFundViewModel } from './UnitTransferAddSourceFundViewModel';
import {
    UnitTransferAddSourceFundViewModelFromJSON,
    UnitTransferAddSourceFundViewModelFromJSONTyped,
    UnitTransferAddSourceFundViewModelToJSON,
} from './UnitTransferAddSourceFundViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsAddUnitTransferViewModel
 */
export interface InvestmentDetailsAddUnitTransferViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAddUnitTransferViewModel
     */
    id?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsAddUnitTransferViewModel
     */
    hasUnitTransfer: IAPYESORNO;
    /**
     * 
     * @type {IAPTRANSFERMETHOD}
     * @memberof InvestmentDetailsAddUnitTransferViewModel
     */
    transferMethodId?: IAPTRANSFERMETHOD;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAddUnitTransferViewModel
     */
    totalEstimatedUnitTransferAmount?: number;
    /**
     * 
     * @type {Array<UnitTransferAddSourceFundViewModel>}
     * @memberof InvestmentDetailsAddUnitTransferViewModel
     */
    funds?: Array<UnitTransferAddSourceFundViewModel>;
    /**
     * 
     * @type {InvestmentDetailsSourceOfMoneySplitViewModel}
     * @memberof InvestmentDetailsAddUnitTransferViewModel
     */
    sourceOfMoneySplit?: InvestmentDetailsSourceOfMoneySplitViewModel;
}

/**
 * Check if a given object implements the InvestmentDetailsAddUnitTransferViewModel interface.
 */
export function instanceOfInvestmentDetailsAddUnitTransferViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasUnitTransfer" in value;

    return isInstance;
}

export function InvestmentDetailsAddUnitTransferViewModelFromJSON(json: any): InvestmentDetailsAddUnitTransferViewModel {
    return InvestmentDetailsAddUnitTransferViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsAddUnitTransferViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsAddUnitTransferViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'hasUnitTransfer': IAPYESORNOFromJSON(json['HasUnitTransfer']),
        'transferMethodId': !exists(json, 'TransferMethodId') ? undefined : IAPTRANSFERMETHODFromJSON(json['TransferMethodId']),
        'totalEstimatedUnitTransferAmount': !exists(json, 'TotalEstimatedUnitTransferAmount') ? undefined : json['TotalEstimatedUnitTransferAmount'],
        'funds': !exists(json, 'Funds') ? undefined : ((json['Funds'] as Array<any>).map(UnitTransferAddSourceFundViewModelFromJSON)),
        'sourceOfMoneySplit': !exists(json, 'SourceOfMoneySplit') ? undefined : InvestmentDetailsSourceOfMoneySplitViewModelFromJSON(json['SourceOfMoneySplit']),
    };
}

export function InvestmentDetailsAddUnitTransferViewModelToJSON(value?: InvestmentDetailsAddUnitTransferViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'HasUnitTransfer': IAPYESORNOToJSON(value.hasUnitTransfer),
        'TransferMethodId': IAPTRANSFERMETHODToJSON(value.transferMethodId),
        'TotalEstimatedUnitTransferAmount': value.totalEstimatedUnitTransferAmount,
        'Funds': value.funds === undefined ? undefined : ((value.funds as Array<any>).map(UnitTransferAddSourceFundViewModelToJSON)),
        'SourceOfMoneySplit': InvestmentDetailsSourceOfMoneySplitViewModelToJSON(value.sourceOfMoneySplit),
    };
}

